import useSourceFlowCollection from "../hooks/useSourceFlowCollection";
import data from "../.sourceflow/consultants.json";

export const useTeam = () => useSourceFlowCollection(data);

export default useTeam;
